<div class="light-control-host" data-cy="light-control-host">
  @if (currentViewLogin) {
    <form [formGroup]="loginFormModel" (ngSubmit)="loginButtonClick()" data-cy="form-login">
      <h3 class="panel-title" data-cy="panel-title-login">Log in to {{ productName }}</h3>
      <div class="flex-center-column margin-top" data-cy="login-container">
        <div class="flex-center-row full-width" data-cy="login-username-container">
          <input
            id="usr-name"
            class="arpio-input"
            data-cy="form-input-username"
            formControlName="username"
            placeholder="Email"
            autocomplete="username"
            focus-element
          />
        </div>
        <div class="flex-center-row full-width" data-cy="login-password-container">
          <input
            id="auth-pword"
            class="arpio-input"
            type="password"
            data-cy="form-input-password"
            formControlName="password"
            placeholder="Password"
            autocomplete="current-password"
          />
        </div>
        <button
          data-cy="button-submit-login"
          busy-button
          [busy]="submitting"
          class="arpio-button"
          type="submit"
          [disabled]="loginButtonDisabled"
        >
          LOGIN
        </button>
        @if (errorText.length > 0) {
          <div data-cy="text-error" class="padding-top error">{{ errorText }}</div>
        }
        @if (allowRegistration) {
          <div class="padding-top" data-cy="register-prompt">
            Need an {{ uiService.productName }} account?
            <a href (click)="$event.preventDefault(); toggleView()" data-cy="link-toggle-register">Sign up</a>
          </div>
        }
        <div class="padding-top" id="forgot-password" data-cy="forgot-password-container">
          <a [routerLink]="uiService.buildResetPasswordUrl()" data-cy="link-forgot-password">Forgot your password?</a>
        </div>
      </div>
    </form>
  } @else {
    <form [formGroup]="registerFormModel" (ngSubmit)="registerButtonClick()" data-cy="form-register">
      <h3 class="panel-title" data-cy="panel-title-register">Register with {{ productName }}</h3>
      <div class="flex-center-column margin-top" data-cy="register-container">
        <div class="flex-center-row full-width" data-cy="register-displayname-container">
          <input
            id="display-name"
            class="arpio-input"
            formControlName="displayName"
            data-cy="form-input-displayName"
            placeholder="Your name"
            autocomplete="name"
            focus-element
          />
        </div>
        <div class="flex-center-row full-width" data-cy="register-username-container">
          <input
            id="user-name"
            class="arpio-input"
            formControlName="username"
            placeholder="Email"
            data-cy="form-input-username"
            autocomplete="username"
          />
        </div>
        <div class="flex-center-row full-width field-issue-container" data-cy="register-password-container">
          <input
            id="register-pword"
            class="arpio-input"
            formControlName="password"
            type="password"
            placeholder="Password"
            data-cy="form-input-password"
            autocomplete="new-password"
          />
          @if (!!passwordError) {
            <div class="field-issue" data-cy="register-password-error">
              <i class="fa-utility fa-semibold fa-circle-exclamation"></i> {{ passwordError }}
            </div>
          }
        </div>
        <div class="flex-center-row full-width field-issue-container" data-cy="register-confirm-password-container">
          <input
            id="confirm-pword"
            class="arpio-input"
            formControlName="confirmPassword"
            type="password"
            placeholder="Confirm password"
            data-cy="form-input-confirmPassword"
            autocomplete="new-password"
          />
          @if (!!confirmPasswordError) {
            <div class="field-issue" data-cy="register-confirm-password-error">
              <i class="fa-utility fa-semibold fa-circle-exclamation"></i> {{ confirmPasswordError }}
            </div>
          }
        </div>
        <div id="tos-checkbox" class="flex-center-row full-width" data-cy="register-tos-container">
          <input
            id="product-name"
            class="arpio-checkbox"
            type="checkbox"
            formControlName="agreeToTerms"
            data-cy="form-input-agreeToTerms"
          />
          <div class="spacer" data-cy="tos-text">
            I agree to the {{ uiService.productName }}
            <a target="_blank" [href]="uiService.termsOfServiceUrl" data-cy="link-tos">terms of service.</a>
          </div>
        </div>
        <button
          busy-button
          [busy]="submitting"
          class="arpio-button"
          type="submit"
          [disabled]="registerButtonDisabled"
          data-cy="button-submit-register"
        >
          REGISTER
        </button>
        @if (errorText.length > 0) {
          <div class="padding-top error" data-cy="register-error">{{ errorText }}</div>
        }
        <div class="padding-top" data-cy="login-prompt">
          Already have an Arpio account?
          <a href (click)="$event.preventDefault(); toggleView()" data-cy="link-toggle-login">Log in</a>
        </div>
      </div>
    </form>
  }
</div>
